module.exports = __webpack_public_path__ + "static/img/R.3027374.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/R.webp
// module id = YCdc
// module chunks = 0